import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { verify } from "../services/ssoService";
import { ResultCodeEnum } from "../data/ResultCodeEnum";
import BackDrop from "../components/backDrop/BackDrop";

const RequireAuth = () => {
  const initialToken = localStorage.getItem(process.env.REACT_APP_TOKENNAME);
  const [isTokenValid, setIsTokenValid] = useState(null); // null for loading, true for valid, false for invalid
  const { i18n } = useTranslation();
  const pathname = window.location.pathname;
  const url = window.location.origin + pathname;

  useEffect(() => {
    const verifyToken = async () => {
      if (initialToken) {
        try {
          // Call the API to verify the token
          const response = await axios.post(
            `${process.env.REACT_APP_API_URLSSO}${verify}`,
            {},
            {
              headers: {
                Token: initialToken,
              },
            }
          );
          if (
            response.status === 200 &&
            response.data.Result === ResultCodeEnum.Ok
          ) {
            setIsTokenValid(true); // Token is valid
          } else {
            setIsTokenValid(false); // Token is invalid
          }
        } catch (error) {
          setIsTokenValid(false); // Error verifying token
        }
      } else {
        setIsTokenValid(false); // No token found
      }
    };

    verifyToken();
  }, [initialToken]);
  if (isTokenValid === null) {
    // Show loading spinner while verifying the token
    return <BackDrop open={true} />;
  }
  if (isTokenValid) {
    // Token is valid, show the protected component
    return <Outlet />;
  } else {
    // Token is invalid, redirect to the authentication page
    const redirectUrl = `${process.env.REACT_APP_AUTHENTICATIONPATH}/${
      i18n.language
    }?callbackUrl=${encodeURIComponent(url)}`;
    window.location.href = redirectUrl;
    return null;
  }
};

export default RequireAuth;
